"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const signalR = __importStar(require("@microsoft/signalr"));
function startSignalRConnection({ name, url, accessToken, defaultMethodNameToListen, callback, onStop, }) {
    return __awaiter(this, void 0, void 0, function* () {
        let isStopped = false;
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(url, { accessTokenFactory: () => accessToken })
            // .configureLogging(signalR.LogLevel.Trace)
            .withAutomaticReconnect()
            .build();
        const start = () => __awaiter(this, void 0, void 0, function* () {
            console.log(`${name} starting signalR`);
            if (!isStopped) {
                yield connection
                    .start()
                    .then((res) => {
                    console.log(`${name} signalR connection has started`);
                })
                    .catch((err) => {
                    console.error(err);
                    console.log(`${name} error encountered while starting signalR. Retrying in 5 seconds`);
                    setTimeout(() => {
                        start();
                    }, 5000);
                });
            }
        });
        connection.onclose(() => {
            console.log(`${name} signalR disconnected`);
            setTimeout(function () {
                start();
            }, 5000);
        });
        connection.onreconnecting((err) => console.log(`${name} signalR err reconnecting  `, err));
        connection.on(defaultMethodNameToListen, (message) => {
            // console.log(`${name}_${defaultMethodNameToListen}`, message);
            callback(message);
        });
        start();
        return {
            stop() {
                return __awaiter(this, void 0, void 0, function* () {
                    isStopped = true;
                    yield connection.stop();
                    if (onStop) {
                        onStop();
                    }
                });
            },
        };
    });
}
exports.default = startSignalRConnection;
